import { IconButton } from '@mui/material';
import { X } from 'lucide-react';

import { AnimatedModalProps, animatedModal } from '@labradorsports/components';
import { Exception } from '@labradorsports/utils';

import ErrorDetails from '../error-details/error-details.js';

interface Props {
    error: Exception;
    onClose?: () => void;
}

const ErrorModal: FC<AnimatedModalProps & Props> = ({ error, onClose }) => {
    return (
        <div>
            {onClose ? (
                <IconButton onClick={onClose} className="close-button">
                    <X />
                </IconButton>
            ) : null}
            <ErrorDetails error={error} />
        </div>
    );
};

export default animatedModal(ErrorModal);
